import { DOCUMENTS_PAGE_SIZE } from '../constants/constants';
import { DocumentType } from '../types/Podcast';

/**
 * Checks if there are more documents to load based on the pagination size.
 * @param documents - The array of documents.
 * @returns A boolean indicating if there are more documents to load.
 */
export function hasMoreDocumentsCheck(documents: DocumentType[]) {
  if (!documents || documents.length === 0) {
    return false;
  }
  
  return documents.length % DOCUMENTS_PAGE_SIZE === 0;
}
